<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
  >
    <template #activator="{ on: dialogOn, attrs: dialogAttrs }">
      <ActivatorButton
        :parent-attrs="dialogAttrs"
        :parent-on="dialogOn"
        :icon-or-title="buttonTitle"
        :tooltip-text="title"
        :disabled="disabled"
        :v-btn-props="{ class: 'flat-button border' }"
      />
    </template>

    <v-card>
      <v-card-title>{{ title }}</v-card-title>

      <v-card-text>
        <v-text-field
          v-model="casText"
          append-icon="mdi-magnify"
          hide-details
          autofocus
          label="Please enter CASRN"
          single-line
          style="max-width: 15em"
        />

        <v-spacer />

        <v-card-text>
          <v-container>
            <v-row
              v-if="rootCASRN && rootCASRN == askedCASRN"
              style="font-size: larger"
            >
              Active Root CARSN: {{ rootCASRN }}
            </v-row>
            <v-row
              v-if="rootCASRN && rootCASRN != askedCASRN"
              style="color: red; font-size: larger"
            >
              {{ askedCASRN }} Not Active. Root CARSN: {{ rootCASRN }}
            </v-row>
            <v-row
              v-for="(value, key, index) in this.cc"
              :key="index"
            >
              <v-col style="font-size: larger">
                {{ key }} :
                <v-col
                  v-if="key != 'images'"
                  cols="*"
                >
                  {{ value }}
                </v-col>
                <v-col
                  v-else
                  cols="*"
                >
                  <embed :src="image(value[0])" />
                </v-col>
              </v-col>
            </v-row>
          </v-container>
          <v-progress-linear
            v-if="searching"
            indeterminate
          />
        </v-card-text>

        <div
          v-if="message"
          style="color: red; font-size: larger"
        >
          {{ message }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="dialog = false"
          aria-label="Close"
        >
          Close
        </v-btn>
        <v-btn
          @click="onOk"
          aria-label="Lookup"
        >
          Lookup
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DialogBase from '@/components/dialogs/DialogBase.vue'
import { getErrorMessage, RESOLVER_URL } from '@/main'
import { defaultVTooltipProps } from '@/utils/defaultProps'
import ActivatorButton from '@/components/ActivatorButton.vue'

export default {
  components: { ActivatorButton },
  mixins: [DialogBase],

  data: () => ({
    message: null,
    searching: false,
    replaced: null,
    rootCASRN: null,
    askedCASRN: null,
    cc: null,
    casText: '',
    defaultVTooltipProps,
  }),
  methods: {
    image(val) {
      return val == null ? null : 'data:image/svg+xml;base64,' + btoa(val)
    },
    onOk() {
      this.$axios
        .get(`${RESOLVER_URL}/lookupCASRN?query=${encodeURIComponent(this.casText)}`)
        .then((response) => {
          this.searching = false
          if (!response.data || !response.data.rn) {
            this.message = 'Not found'
            this.replaced = null
            this.rootCASRN = null
            this.askedCASRN = null
            this.cc = null
          } else {
            this.message = null
            this.replaced = response.data.replacedRns
            this.rootCASRN = response.data.rn
            this.cc = response.data
            this.askedCASRN = this.casText
          }
        })
        .catch((error) => {
          this.searching = false
          this.message = getErrorMessage(error)
          this.replaced = null
          this.rootCASRN = null
          this.askedCASRN = null
          this.cc = null
        })
    },
  },
}
</script>
